<script setup lang="ts">
import { Icon } from '@iconify/vue2'
import { computed } from 'vue'

const title = computed(() => 'Nenhum registro encontrado')

const subtitle = computed(() => 'Aguarde a notificação dos alertas para visualizar os registros.')

const icon = computed(() => 'fa6-solid:folder-open')
</script>

<template>
	<div class="flex items-center w-full flex-col gap-2 p-16">
		<Icon
			:icon="icon"
			class="text-4xl text-gray-dark"
		/>
		<p class="text-default">{{ title }}</p>
		<p class="text-default text-center">{{ subtitle }}</p>
	</div>
</template>
